/**
 * The palette a tag or list can be marked with.
 *
 * Deliberately small, and deliberately without purple: the accent marks the
 * active thing and nothing else, so letting a tag borrow it would make
 * "selected" ambiguous. Everything here is desaturated to the same degree as
 * the priority colours, so a sidebar full of marked lists still reads as chrome
 * rather than as decoration.
 *
 * Stored by key, not by hex — a palette change stays a one-file edit, and the
 * value survives a future light theme.
 */
export interface Swatch {
  key: string;
  label: string;
  hex: string;
}

export const SWATCHES: Swatch[] = [
  { key: 'red', label: 'Red', hex: '#E5484D' },
  { key: 'amber', label: 'Amber', hex: '#E5A03A' },
  { key: 'green', label: 'Green', hex: '#3DA867' },
  { key: 'teal', label: 'Teal', hex: '#3DA8A0' },
  { key: 'blue', label: 'Blue', hex: '#4A8FE7' },
  { key: 'pink', label: 'Pink', hex: '#D9569A' },
  { key: 'slate', label: 'Slate', hex: '#7A8494' },
];

const BY_KEY = new Map(SWATCHES.map((s) => [s.key, s]));

/** Falls back to the neutral dot colour, so an unknown key never breaks a row. */
export function colorOf(key: string | null | undefined): string | null {
  if (!key) return null;
  return BY_KEY.get(key)?.hex ?? null;
}

export const labelOf = (key: string | null | undefined) =>
  (key && BY_KEY.get(key)?.label) || 'No colour';
